// state
const state = {
    errors: {},
    resource: {},
    user: null,
    auth: {}
}

// getters
const getters = {}

// actions
const actions = {

    resetErrors({commit}) {
        commit('setErrors', {})
    }

} 
 
// mutations
const mutations = {

    setErrors(state, value) {
        state.errors = value
    },

    pushErrors(state, errors) {
        _.each(errors, (value, key) => {
            Vue.set(state.errors, key, value)
        })
    },

    setResource(state, value) {
        state.resource = value
    },

    setAuth(state, value) {
        state.auth = value
    },

    setUser(state, value) {
        state.user = value
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}